import { FunctionComponent, useCallback } from "react";
import { MenuItem as MenuItemType } from "@dto/MenuItem";
import { MenuItem } from "./MenuItem";
import { setMenuItemAction } from "@store/menuItem/actions/setMenuItemAction";
import { useAppDispatch } from "@store/store";
import { useNavigate } from "@hooks/useNavigate/useNavigate";
import { toggleHomeMenu } from "@store/kiosk/kioskReducer";
interface EntityMenuItemProps {
  menuItem: MenuItemType;
}

export const EntityMenuItem: FunctionComponent<EntityMenuItemProps> = ({
  menuItem,
}) => {
  const { name, entity, analyticsPath, inactiveIconUrl, activeIconUrl } =
    menuItem;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handlePress = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      navigate("/");
      dispatch(setMenuItemAction(menuItem));
      dispatch(toggleHomeMenu());
    },
    [dispatch, menuItem, navigate],
  );

  return (
    <MenuItem
      label={name}
      className={entity}
      inactiveIconUrl={inactiveIconUrl}
      activeIconUrl={activeIconUrl}
      handlePress={handlePress}>
      <a
        href={analyticsPath}
        title={`Navigate to ${name}`}
        onClick={handlePress}>
        {name}
      </a>
    </MenuItem>
  );
};
